export default function getResource(label) {
    const resources = {
        compareProducts: 'Compare Products',
        emptySlot: 'Empty',
        colors: 'Colors',
        color: 'Color',
        sizes: 'Sizes',
        size: 'size',
        standardSize: 'Standard size: ',
        ratingsAndReviews: 'Rating & Reviews',
        prosMentioned: 'Pros Mentioned',
        consMentioned: 'Cons Mentioned',
        overview: 'Overview',
        ingredients: 'Ingredients',
        pickupAndDelivery: 'Pickup & Delivery',
        showAll: 'Show all'
    };

    return resources[label];
}
